import React, { useState} from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import queryString from 'query-string';
import { useContext } from 'react';
import Lottie from 'react-lottie';
import success_lottie  from '../../media/lotties/success.json'
import UserProvider from '../../context/UserContext';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Checkbox } from '@material-ui/core';


const defaultOptions = {
    animationData: success_lottie,
    loop: false,
	autoplay: true,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

const CardField = ({onChange}) => (
    <div className="FormRow">
        <PaymentElement id="payment-element" onChange={onChange}/>
    </div>
);

const SubmitButton = ({processing, error, children, disabled}) => (
    <button
        className={`SubmitButton ${error ? 'SubmitButton--error' : ''} pay-button`}
        type="submit"
        disabled={processing || disabled}
    >
        {processing ? 'Processing...' : children}
    </button>
);

const ErrorMessage = ({children}) => (
    <div className="ErrorMessage item" role="alert">
        <i className="fas fa-times-circle"></i><h6 className="align-svg">{children}</h6>
    </div>
);

const CheckoutForm = () => {
    
    const Data = useContext(UserProvider.context);
    const stockInfo = Data.stockInfo

    const label = (  <span className="term-label">I agree to the <a className="term-link" rel="noopener noreferrer" target="_blank" href="https://infinitbot.com/terms">Terms of Service</a> and <a className="term-link" rel="noopener noreferrer" target="_blank" href="https://infinitbot.com/privacy">Privacy Policy</a></span> )

    const stripe = useStripe()
    const elements = useElements()
    const [error, setError] = useState(null);
    const [cardComplete, setCardComplete] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [paymentError, setPaymentError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        if (!stripe || !elements) {
          // Stripe.js has not loaded yet. Make sure to disable
          // form submission until Stripe.js has loaded.
          return;
        }

        if (cardComplete && document.getElementById("terms-checkbox").checked === true) {
            setProcessing(true);
        }
        
        if(document.getElementById("terms-checkbox").checked === false){
            setPaymentError('You must accept our terms and conditions')
            setProcessing(false);
            return
        }

        const payload = await stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: window.location.href,
            },
            redirect: "if_required"
        });

        if (payload.error) {
            setError(payload.error);
            setProcessing(false);
        }else {
            const urlquery = window.location.search;
            const urlParams = new URLSearchParams(urlquery);
            const password = urlParams.get('password')

            let data = {setup_intent_id : payload.setupIntent.id, password: password}
            
            fetch(`${process.env.REACT_APP_API_URL}/purchase/`,{
                headers: {'Accept': 'application/json', 'Content-Type':'application/x-www-form-urlencoded'},
                credentials: 'include',
                body: queryString.stringify(data),
                method: 'POST',
            })
            .then(function (res) {
                if(res.status === 200){
                    res.json().then(function(data){
                        if(data.success === true){
                            localStorage.setItem('purchased_infinit', 'true')
                            setSuccess(true)
                            setProcessing(false);
                            setTimeout(() => { window.location.reload(false) }, 1380); 
                        }
                })
                }
                else if(res.status === 400){
                    res.json().then(function(data){
                        setPaymentError(data.message)
                        setProcessing(false);
                        if (data.message.toLowerCase() === 'out of stock'){
                            setTimeout(() => { window.location.reload(false) }, 2000);
                        }
                })
                }
                else{
                    setPaymentError('Internal Server Error')
                    console.log('Internal Server Error');
                    setProcessing(false);
                }
            })    
            .catch(err => {
                console.log(err);
                setProcessing(false);
            });
        }
      };

    return success ? (
        <div className="success-lootie-holder">
            <div className="success-lootie-holder">
            <Lottie options={defaultOptions}
                            isClickToPauseDisabled={true} 
                            height={100}
                            width={100}
                            isStopped={!success}
                            isPaused={!success}
                            />
            </div>
        </div>

    ) : (
        <form className="card-form" onSubmit={handleSubmit}>
            <div className="FormGroup">
                <CardField
                    onChange={(e) => {
                        setError(e.error);
                        setPaymentError("")
                        setCardComplete(e.complete);
                    }}
                />
            </div>
            <div className="item pay-error-holder">
                {(error && <ErrorMessage>{error.message}</ErrorMessage>) || paymentError && <ErrorMessage>{paymentError}</ErrorMessage>}
            </div>
            <div className="check-box-holder">
            <FormControlLabel
                control={<Checkbox className="check-box"
                    id="terms-checkbox"
                    value="terms"
                    />}
                    label={label}
                    disabled={processing}
            />
            </div>
            <div className="pay-button-holder">
                <SubmitButton processing={processing} error={error} disabled={!stripe}>
                    Pay {stockInfo.onetime}€
                </SubmitButton>
            </div>
            <div className="item disclaimer-holder">
                <i className="fas fa-exclamation-circle"></i><h6 className="align-svg">{stockInfo.onetime}€ first month, then {stockInfo.recurring}€ per month, billed monthly</h6>
            </div>
        </form>
    )
};

export default CheckoutForm;